// 收貨管理與品質檢驗系統資料模型
// Receiving Management & Quality Inspection System Data Model

// 收貨記錄
export const receivingRecords = [
  {
    id: 'rcv-2025-001',
    receiving_number: 'RCV-2025-001',
    po_id: 'po-2025-001',
    po_number: 'PO-2025-001',
    supplier_id: 'sup-001',
    supplier_name: '東亞電子科技股份有限公司',
    status: 'completed',
    received_date: '2025-01-20T10:30:00',
    received_by: '王收貨員',
    delivery_note: 'DN-2025-001',
    carrier: '順豐快遞',
    tracking_number: 'SF123456789',
    delivery_address: '台北市信義區信義路五段7號',
    items: [
      {
        id: 'rcv-item-001',
        po_item_id: 'po-item-001',
        product_id: 'prod-001',
        product_name: '鋁合金材料 A-grade',
        ordered_quantity: 3000,
        received_quantity: 2950,
        unit: '公斤',
        unit_price: 50,
        total_value: 147500,
        location: 'A-01-001',
        batch_number: 'BATCH-2025-001',
        expiry_date: '2026-01-20',
        quality_status: 'passed',
        inspection_id: 'qc-2025-001',
        notes: '少收50公斤，已通知供應商'
      }
    ],
    total_items: 1,
    total_quantity: 2950,
    total_value: 147500,
    discrepancies: [
      {
        type: 'quantity_shortage',
        description: '數量短缺50公斤',
        severity: 'minor',
        action_taken: '已通知供應商補發'
      }
    ],
    documents: [
      {
        id: 'rcv-doc-001',
        type: 'delivery_note',
        file_name: '送貨單_DN-2025-001.pdf',
        uploaded_at: '2025-01-20T10:45:00'
      },
      {
        id: 'rcv-doc-002',
        type: 'quality_certificate',
        file_name: '品質證書_QC-2025-001.pdf',
        uploaded_at: '2025-01-20T11:00:00'
      }
    ],
    created_at: '2025-01-20T10:30:00',
    updated_at: '2025-01-20T14:20:00'
  },
  {
    id: 'rcv-2025-002',
    receiving_number: 'RCV-2025-002',
    po_id: 'po-2025-002',
    po_number: 'PO-2025-002',
    supplier_id: 'sup-002',
    supplier_name: '華南機械製造有限公司',
    status: 'in_progress',
    received_date: '2025-01-22T14:15:00',
    received_by: '李收貨員',
    delivery_note: 'DN-2025-002',
    carrier: '宅急便',
    tracking_number: 'YM987654321',
    delivery_address: '台中市西屯區台灣大道三段99號',
    items: [
      {
        id: 'rcv-item-002',
        po_item_id: 'po-item-002',
        product_id: 'prod-002',
        product_name: '精密機械零件',
        ordered_quantity: 500,
        received_quantity: 500,
        unit: '個',
        unit_price: 120,
        total_value: 60000,
        location: 'B-02-003',
        batch_number: 'BATCH-2025-002',
        quality_status: 'pending',
        inspection_id: 'qc-2025-002',
        notes: '待品質檢驗'
      }
    ],
    total_items: 1,
    total_quantity: 500,
    total_value: 60000,
    discrepancies: [],
    documents: [
      {
        id: 'rcv-doc-003',
        type: 'delivery_note',
        file_name: '送貨單_DN-2025-002.pdf',
        uploaded_at: '2025-01-22T14:30:00'
      }
    ],
    created_at: '2025-01-22T14:15:00',
    updated_at: '2025-01-22T14:30:00'
  },
  {
    id: 'rcv-2025-003',
    receiving_number: 'RCV-2025-003',
    po_id: 'po-2025-003',
    po_number: 'PO-2025-003',
    supplier_id: 'sup-004',
    supplier_name: '新科技材料研發股份有限公司',
    status: 'rejected',
    received_date: '2025-01-18T09:45:00',
    received_by: '陳收貨員',
    delivery_note: 'DN-2025-003',
    carrier: '黑貓宅急便',
    tracking_number: 'TC456789123',
    delivery_address: '新竹市東區光復路二段101號',
    items: [
      {
        id: 'rcv-item-003',
        po_item_id: 'po-item-003',
        product_id: 'prod-003',
        product_name: '高分子材料',
        ordered_quantity: 1000,
        received_quantity: 1000,
        unit: '公斤',
        unit_price: 85,
        total_value: 85000,
        location: 'C-03-001',
        batch_number: 'BATCH-2025-003',
        quality_status: 'failed',
        inspection_id: 'qc-2025-003',
        notes: '品質檢驗不合格，已退回供應商'
      }
    ],
    total_items: 1,
    total_quantity: 1000,
    total_value: 85000,
    discrepancies: [
      {
        type: 'quality_failure',
        description: '材料純度不符合規格要求',
        severity: 'major',
        action_taken: '全數退回供應商'
      }
    ],
    documents: [
      {
        id: 'rcv-doc-004',
        type: 'delivery_note',
        file_name: '送貨單_DN-2025-003.pdf',
        uploaded_at: '2025-01-18T10:00:00'
      },
      {
        id: 'rcv-doc-005',
        type: 'rejection_notice',
        file_name: '退貨通知_RN-2025-003.pdf',
        uploaded_at: '2025-01-18T16:30:00'
      }
    ],
    created_at: '2025-01-18T09:45:00',
    updated_at: '2025-01-18T16:30:00'
  }
];

// 品質檢驗記錄
export const qualityInspections = [
  {
    id: 'qc-2025-001',
    inspection_number: 'QC-2025-001',
    receiving_id: 'rcv-2025-001',
    po_id: 'po-2025-001',
    product_id: 'prod-001',
    product_name: '鋁合金材料 A-grade',
    batch_number: 'BATCH-2025-001',
    inspection_type: 'incoming',
    inspection_date: '2025-01-20T11:30:00',
    inspector: '張品管',
    inspection_plan: 'IP-ALU-001',
    sample_size: 50,
    total_quantity: 2950,
    status: 'passed',
    overall_result: 'accept',
    tests: [
      {
        id: 'test-001',
        test_name: '化學成分分析',
        test_type: 'chemical',
        specification: 'Al≥99.5%, Si≤0.25%, Fe≤0.40%',
        result: 'Al=99.7%, Si=0.18%, Fe=0.32%',
        status: 'passed',
        tested_by: '化學實驗室',
        tested_at: '2025-01-20T13:00:00'
      },
      {
        id: 'test-002',
        test_name: '機械性能測試',
        test_type: 'mechanical',
        specification: '抗拉強度≥90MPa, 延伸率≥20%',
        result: '抗拉強度=95MPa, 延伸率=22%',
        status: 'passed',
        tested_by: '機械實驗室',
        tested_at: '2025-01-20T14:30:00'
      },
      {
        id: 'test-003',
        test_name: '外觀檢查',
        test_type: 'visual',
        specification: '表面光滑無瑕疵',
        result: '表面狀況良好',
        status: 'passed',
        tested_by: '張品管',
        tested_at: '2025-01-20T11:45:00'
      }
    ],
    defects: [],
    corrective_actions: [],
    certificate_issued: true,
    certificate_number: 'QC-CERT-2025-001',
    approved_by: '品管主管',
    approved_at: '2025-01-20T15:00:00',
    notes: '所有測試項目均符合規格要求',
    created_at: '2025-01-20T11:30:00',
    updated_at: '2025-01-20T15:00:00'
  },
  {
    id: 'qc-2025-002',
    inspection_number: 'QC-2025-002',
    receiving_id: 'rcv-2025-002',
    po_id: 'po-2025-002',
    product_id: 'prod-002',
    product_name: '精密機械零件',
    batch_number: 'BATCH-2025-002',
    inspection_type: 'incoming',
    inspection_date: '2025-01-22T15:00:00',
    inspector: '李品管',
    inspection_plan: 'IP-MECH-001',
    sample_size: 25,
    total_quantity: 500,
    status: 'in_progress',
    overall_result: 'pending',
    tests: [
      {
        id: 'test-004',
        test_name: '尺寸測量',
        test_type: 'dimensional',
        specification: '直徑: 25±0.02mm, 長度: 50±0.05mm',
        result: '進行中',
        status: 'in_progress',
        tested_by: '精密測量室',
        tested_at: '2025-01-22T15:30:00'
      },
      {
        id: 'test-005',
        test_name: '表面粗糙度',
        test_type: 'surface',
        specification: 'Ra≤0.8μm',
        result: '待測試',
        status: 'pending',
        tested_by: '表面測試室',
        tested_at: null
      }
    ],
    defects: [],
    corrective_actions: [],
    certificate_issued: false,
    certificate_number: null,
    approved_by: null,
    approved_at: null,
    notes: '檢驗進行中',
    created_at: '2025-01-22T15:00:00',
    updated_at: '2025-01-22T15:30:00'
  },
  {
    id: 'qc-2025-003',
    inspection_number: 'QC-2025-003',
    receiving_id: 'rcv-2025-003',
    po_id: 'po-2025-003',
    product_id: 'prod-003',
    product_name: '高分子材料',
    batch_number: 'BATCH-2025-003',
    inspection_type: 'incoming',
    inspection_date: '2025-01-18T14:00:00',
    inspector: '王品管',
    inspection_plan: 'IP-POLY-001',
    sample_size: 20,
    total_quantity: 1000,
    status: 'failed',
    overall_result: 'reject',
    tests: [
      {
        id: 'test-006',
        test_name: '純度分析',
        test_type: 'chemical',
        specification: '純度≥99.0%',
        result: '純度=97.5%',
        status: 'failed',
        tested_by: '化學實驗室',
        tested_at: '2025-01-18T15:30:00'
      },
      {
        id: 'test-007',
        test_name: '分子量測定',
        test_type: 'physical',
        specification: 'Mw=50,000±5,000',
        result: 'Mw=42,000',
        status: 'failed',
        tested_by: '物理實驗室',
        tested_at: '2025-01-18T16:00:00'
      }
    ],
    defects: [
      {
        id: 'defect-001',
        type: 'specification_deviation',
        description: '純度低於規格要求',
        severity: 'major',
        quantity_affected: 1000,
        root_cause: '供應商製程問題'
      },
      {
        id: 'defect-002',
        type: 'specification_deviation',
        description: '分子量不符合規格',
        severity: 'major',
        quantity_affected: 1000,
        root_cause: '原料品質問題'
      }
    ],
    corrective_actions: [
      {
        id: 'ca-001',
        action: '全數退回供應商',
        responsible: '採購部',
        due_date: '2025-01-20',
        status: 'completed'
      },
      {
        id: 'ca-002',
        action: '要求供應商改善製程',
        responsible: '品管部',
        due_date: '2025-01-25',
        status: 'in_progress'
      }
    ],
    certificate_issued: false,
    certificate_number: null,
    approved_by: '品管主管',
    approved_at: '2025-01-18T16:30:00',
    notes: '材料不符合規格要求，已全數退回',
    created_at: '2025-01-18T14:00:00',
    updated_at: '2025-01-18T16:30:00'
  }
];

// 庫存更新記錄
export const inventoryUpdates = [
  {
    id: 'inv-update-001',
    receiving_id: 'rcv-2025-001',
    product_id: 'prod-001',
    product_name: '鋁合金材料 A-grade',
    transaction_type: 'receipt',
    quantity: 2950,
    unit: '公斤',
    location: 'A-01-001',
    batch_number: 'BATCH-2025-001',
    cost_per_unit: 50,
    total_value: 147500,
    previous_stock: 1200,
    new_stock: 4150,
    updated_by: '王收貨員',
    updated_at: '2025-01-20T14:30:00',
    notes: '收貨入庫'
  },
  {
    id: 'inv-update-002',
    receiving_id: 'rcv-2025-003',
    product_id: 'prod-003',
    product_name: '高分子材料',
    transaction_type: 'return',
    quantity: -1000,
    unit: '公斤',
    location: 'C-03-001',
    batch_number: 'BATCH-2025-003',
    cost_per_unit: 85,
    total_value: -85000,
    previous_stock: 1000,
    new_stock: 0,
    updated_by: '陳收貨員',
    updated_at: '2025-01-18T16:45:00',
    notes: '品質不合格退回'
  }
];

// 收貨管理儀表板資料
export const receivingDashboard = {
  summary: {
    total_receipts: 156,
    pending_receipts: 8,
    completed_receipts: 142,
    rejected_receipts: 6,
    total_value: 15750000,
    avg_processing_time: 2.3,
    on_time_receipt_rate: 89.2,
    quality_pass_rate: 94.8
  },
  recent_receipts: [
    {
      id: 'rcv-2025-001',
      receiving_number: 'RCV-2025-001',
      supplier_name: '東亞電子科技股份有限公司',
      received_date: '2025-01-20',
      total_value: 147500,
      status: 'completed',
      quality_status: 'passed'
    },
    {
      id: 'rcv-2025-002',
      receiving_number: 'RCV-2025-002',
      supplier_name: '華南機械製造有限公司',
      received_date: '2025-01-22',
      total_value: 60000,
      status: 'in_progress',
      quality_status: 'pending'
    },
    {
      id: 'rcv-2025-003',
      receiving_number: 'RCV-2025-003',
      supplier_name: '新科技材料研發股份有限公司',
      received_date: '2025-01-18',
      total_value: 85000,
      status: 'rejected',
      quality_status: 'failed'
    }
  ],
  pending_inspections: [
    {
      id: 'qc-2025-002',
      inspection_number: 'QC-2025-002',
      product_name: '精密機械零件',
      quantity: 500,
      inspector: '李品管',
      due_date: '2025-01-24',
      priority: 'high'
    }
  ],
  quality_trends: {
    monthly_pass_rates: [
      { month: '2024-07', pass_rate: 96.2 },
      { month: '2024-08', pass_rate: 94.8 },
      { month: '2024-09', pass_rate: 97.1 },
      { month: '2024-10', pass_rate: 95.3 },
      { month: '2024-11', pass_rate: 93.7 },
      { month: '2024-12', pass_rate: 94.8 }
    ],
    defect_categories: [
      { category: '尺寸偏差', count: 12, percentage: 35.3 },
      { category: '材料成分', count: 8, percentage: 23.5 },
      { category: '表面缺陷', count: 7, percentage: 20.6 },
      { category: '包裝問題', count: 4, percentage: 11.8 },
      { category: '其他', count: 3, percentage: 8.8 }
    ]
  },
  supplier_performance: [
    {
      supplier_id: 'sup-001',
      supplier_name: '東亞電子科技股份有限公司',
      total_receipts: 45,
      pass_rate: 97.8,
      avg_lead_time: 7.2,
      on_time_rate: 95.6
    },
    {
      supplier_id: 'sup-002',
      supplier_name: '華南機械製造有限公司',
      total_receipts: 32,
      pass_rate: 93.8,
      avg_lead_time: 12.5,
      on_time_rate: 87.5
    },
    {
      supplier_id: 'sup-004',
      supplier_name: '新科技材料研發股份有限公司',
      total_receipts: 28,
      pass_rate: 89.3,
      avg_lead_time: 9.8,
      on_time_rate: 92.9
    }
  ]
};

// 品質檢驗標準
export const inspectionStandards = [
  {
    id: 'IP-ALU-001',
    plan_name: '鋁合金材料檢驗計劃',
    product_category: 'aluminum',
    inspection_type: 'incoming',
    sample_size_rule: 'AQL 2.5',
    tests: [
      {
        test_name: '化學成分分析',
        test_type: 'chemical',
        specification: 'Al≥99.5%, Si≤0.25%, Fe≤0.40%',
        equipment: 'X-ray螢光光譜儀',
        frequency: '每批次'
      },
      {
        test_name: '機械性能測試',
        test_type: 'mechanical',
        specification: '抗拉強度≥90MPa, 延伸率≥20%',
        equipment: '萬能試驗機',
        frequency: '每批次'
      },
      {
        test_name: '外觀檢查',
        test_type: 'visual',
        specification: '表面光滑無瑕疵',
        equipment: '目視檢查',
        frequency: '100%檢查'
      }
    ]
  },
  {
    id: 'IP-MECH-001',
    plan_name: '機械零件檢驗計劃',
    product_category: 'mechanical',
    inspection_type: 'incoming',
    sample_size_rule: 'AQL 1.5',
    tests: [
      {
        test_name: '尺寸測量',
        test_type: 'dimensional',
        specification: '依圖面規格',
        equipment: '三次元測量儀',
        frequency: '每批次'
      },
      {
        test_name: '表面粗糙度',
        test_type: 'surface',
        specification: 'Ra≤0.8μm',
        equipment: '表面粗糙度儀',
        frequency: '每批次'
      },
      {
        test_name: '硬度測試',
        test_type: 'hardness',
        specification: 'HRC 45-50',
        equipment: '洛氏硬度計',
        frequency: '每批次'
      }
    ]
  }
]; 